import Vue from 'vue'
import { PublicationModel as Model } from './Model'

import { createComponentProgrammatic } from '@/helpers/createComponentProgrammatic'


export const MODULE_NAME = 'publications'

export const createPublicationsParticipantModalModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationsParticipantModal" */
    './Participants/PublicationsParticipantsModal.vue'
  )

  return createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )
}

export const createPublicationsCuratorModalModal = (parent: Vue, propsData: unknown) => {
  const AsyncComponent = import(
    /* webpackChunkName: "PublicationsCuratorsModal" */
    './Curators/PublicationsCuratorsModal.vue'
  )

  return createComponentProgrammatic(
    AsyncComponent,
    parent,
    propsData,
  )
}

export const PUBLICATIONS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: PUBLICATIONS_ROUTES.LAYOUT,
  route: { name: PUBLICATIONS_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-book-open-blank-variant',
} as const
